<template>
  <div></div>
</template>

<script>
export default {
  name: 'Map3D',
  props: {
    feature: {},
    map: {}
  },
  data: function () {
    return {
      source: {},
      mapStyleSheetId: null
    }
  },
  computed: {
    layerID() {
      return 'riser-terrain-2'
    }
  },

  mounted() {
    this.reAddLayer()

    this.mapStyleSheetId = this.map.style.stylesheet.id

    this.map.on('styledata', this.styleDataChangeHandler)
  },

  beforeUnmount() {
    this.map.off('styledata', this.styleDataChangeHandler)

    if (this.map.getLayer(this.layerID)) {
      this.map.removeLayer(this.layerID)
    }

    if (this.map.getSource(this.layerID)) {
      this.map.removeSource(this.layerID)
    }

    this.map.setTerrain()
  },

  methods: {
    reAddLayer() {
      if (this.map.getLayer(this.layerID)) {
        this.map.removeLayer(this.layerID)
      }

      if (this.map.getSource(this.layerID)) {
        this.map.removeSource(this.layerID)
      }

      this.map.setTerrain()

      this.map.addSource(this.layerID, {
        type: 'raster-dem',
        tiles: ['https://s3.amazonaws.com/elevation-tiles-prod/terrarium/{z}/{x}/{y}.png'],
        minzoom: 0,
        maxzoom: 15,
        tileSize: 256,
        encoding: 'terrarium'
      })

      this.map.addLayer({
        id: this.layerID,
        source: this.layerID,
        type: 'hillshade',
        paint: {
          'hillshade-shadow-color': 'rgba(0, 0, 0, 0.1)',
          'hillshade-highlight-color': 'rgba(255, 255, 255, 0.1)'
        }
      })

      this.map.setTerrain({
        source: this.layerID,
        exaggeration: 1.5
      })
    },

    styleDataChangeHandler(newMap) {
      if (this.mapStyleSheetId === newMap.style.stylesheet.id) {
        return
      }

      this.map.once('idle', this.reAddLayer)

      this.mapStyleSheetId = newMap.style.stylesheet.id
    }
  }
}
</script>

<style lang="sass"></style>
